// extracted by mini-css-extract-plugin
export var addViewLink = "_d-1";
export var availabilityIcon = "_d-16";
export var availabilitySelectionIcon = "_d-15";
export var backButton = "_d-2";
export var backIcon = "_d-z";
export var conversationCount = "_d-3";
export var dragHandle = "_d-5";
export var dropdown = "_d-e";
export var dropdownIcon = "_d-7";
export var dropdownOption = "_d-6";
export var dropdownTriangle = "_d-d";
export var expand = "_d-f";
export var folder = "_d-i";
export var folderItem = "_d-c";
export var icon = "_d-8";
export var iconRow = "_d-9";
export var image = "_d-a";
export var logo = "_d-b";
export var navContainer = "_d-h";
export var navigationFooter = "_d-g";
export var pageShell = "_d-0";
export var placeholderAvailable = "_d-11";
export var placeholderBox = "_d-14";
export var placeholderBusy = "_d-13";
export var placeholderUnavailable = "_d-12";
export var profile = "_d-k";
export var profileContainer = "_d-m";
export var profileDropdown = "_d-n";
export var profileImage = "_d-l";
export var profileMain = "_d-o";
export var profileSubtitle = "_d-q";
export var profileTitle = "_d-p";
export var reorderIcon = "_d-r";
export var sentLine = "_d-u";
export var settingsHeader = "_d-s";
export var sidenavTextColor = "_d-y";
export var spamLine = "_d-t";
export var subitemWithTag = "_d-4";
export var supportItems = "_d-j";
export var teamText = "_d-10";
export var viewLine = "_d-x";
export var viewLineButton = "_d-w";
export var viewLineButtons = "_d-v";